// extracted by mini-css-extract-plugin
export default {"section":"styles_section__Iwa6J","heading":"styles_heading__NymVB","para":"styles_para__lFQR1"};